import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
  selector: 'app-search-v2',
  templateUrl: './search-v2.component.html',
  styleUrl: './search-v2.component.scss'
})
export class SearchV2Component {
  @Output() search = new EventEmitter<string>();
  @Input() searchValue: string = '';

  private searchSubject = new Subject<string>();

  constructor() {
    this.searchSubject.pipe(
      debounceTime(500)
    ).subscribe(searchString => {
      this.emitSearch(searchString);
    });
  }

  onSearchInputChange(event: Event): void {
    const inputElement = event.target as HTMLInputElement;
    this.searchSubject.next(inputElement.value);
  }

  emitSearch(searchString: string): void {
    this.search.emit(searchString);
  }

}
